<div
  class="warp-question"
  [ngClass]="{
    preview: isPreview,
    displayRichText: question.type.id == eQuestionType.Text
  }"
>
  <div class="warp-asterisk">
    <div class="asterisk">
      <svg-icon
        *ngIf="
          question?.requierd || question.type.id == eQuestionType.Signature
        "
        svgClass="svg-img-mini img"
        src="/assets/images/question-menu/asterisk.svg"
      ></svg-icon>
    </div>
    <div class="question-form" [ngClass]="{ preview: isPreview }">
      <div class="header">
        <div class="right">
          <que-display-title-question
            queDisplayByType
            [name]="'texts'"
            [typeId]="question.type.id"
            [question]="question"
            [isPreview]="isPreview"
          ></que-display-title-question>
          <que-display-big-title-question
            queDisplayByType
            [name]="'title'"
            [typeId]="question.type.id"
            [question]="question"
            [isPreview]="isPreview"
          ></que-display-big-title-question>
        </div>
        <div class="que-icons-left">
        <que-display-api-field-name
          [name]="question.apiExposureFieldName"
        ></que-display-api-field-name>
     <que-smart-tooltip
          *ngIf="question.collectionQuestionId"
        ></que-smart-tooltip>
        <que-display-filter-field 
          [isFilterField]="!!question.isFilterField">
        </que-display-filter-field>
    </div>
      
      </div>
      <div
        queDisplayByType
        [name]="'line'"
        [typeId]="question.type.id"
        class="line"
        *ngIf="question.type.id == eQuestionType.Divider"
      ></div>
      <!-- queDisplayByType [name]="'form'" [typeId]="myType"  -->
      <que-question-form-display
        [isPreview]="isPreview"
        [question]="question"
        [viewAnswer]="viewAnswer"
      ></que-question-form-display>
    </div>
  </div>
  <div
    class="error-requierd none-in-mobile2"
    *ngIf="
      isUser$() &&
      (invalidCurrentQuestion$ | async) &&
      (isVisitedStep$() || isShowError$()) &&
      (question.requierd || question.type.id == eQuestionType.Signature)
    "
    translate
  >
    obligatoryQuestion
  </div>
</div>
